import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed } from "shared/lib/styles";

import IconArrow from "./icon-arrow.svg";

export const StyledSwiperSlide = styled(SwiperSlide)`
  flex-shrink: 0;

  inline-size: fit-content;
`;

export const StyledSwiper = styled(Swiper)`
  inline-size: 100%;

  ${StyledSwiperSlide} {
    inline-size: auto;
    text-size-adjust: 100%;
  }
`;

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  inline-size: 100%;
`;

export const MoreLatestNewsLink = styled(BaseLink)`
  display: inline-block;

  inline-size: 32px;

  color: #2c4692;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  text-decoration: none;

  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`;

export const StyledIconArrow = styled(IconArrow)``;
